import { getRandomId } from '@/common/utils/utils';


const routerNames = {
    CHAPTER: 'chapter',
    NETWORK: 'network',
};

const CHAPTER_MESSAGE_SAVED_SUCCESS = 'Chapter Message Saved Successfully';
const FAILED_CHAPTER_MESSAGE_TO_SAVE = 'Failed to save Chapter Message, try again.';
const NETWORK_MESSAGE_SAVED_SUCCESS = 'Network Message Saved Successfully';
const FAILED_NETWORK_MESSAGE_TO_SAVE = 'Failed to save Network Message, try again.';

export const communityCommonConstant = {
    MAIN: 'Main',
    CONVERSATION: 'Conversation',
    RETURN_TO_HOME_LINK: 'Main Home Conversation',
    THIS_CHAPTER_DOES_NOT_MEET_THE_MINIMUM_STANDARDS: 'Below Standard',
    No_Ranking: 'No Ranking',
    YPO_Atlas: 'YPO Atlas',
    REGIONAL_WAIVERS: 'Regional Waivers',
    REGIONAL_WAIVER_LIST: 'Regional Waiver List',
    CHAPTER_REQUIREMENTS: 'Chapter Requirements',
    COPY_LINK: 'Link copied to clipboard.',
    COPY_FAILED_LINK: 'Failed to copy link.',
    DISPLAY_NON_MEMBER: 'Display to Non Member',
    REMINDER_MESSAGE: 'Does your post adhere to the Network Terms & Conditions?',
    REMINDER_MESSAGE_HTML: `Does your post adhere to the Networks Terms & Conditions? <a href="https://connect.ypowpo.org/Portal/department/networks-and-groups/training-and-tools/network-terms-and-conditions" target='blank' class="content-message__link">Click here</a> to double check.`,
    TOAST_MESSAGES: {
        [routerNames.CHAPTER]: {
          success: CHAPTER_MESSAGE_SAVED_SUCCESS,
          error: FAILED_CHAPTER_MESSAGE_TO_SAVE,
        },
        [routerNames.NETWORK]: {
          success: NETWORK_MESSAGE_SAVED_SUCCESS,
          error: FAILED_NETWORK_MESSAGE_TO_SAVE,
        },
    },
    post: {
        SHARE_SOMETHING: 'Share something with ',
        YOUR_FOLLOWERS: 'your followers',
        LIKES: 'likes',
        LIKE: 'Like',
        TAG: '#',
        SHARE: 'Share',
        COMMENTS: 'Comments',
        ALLOW_COMMENTS: 'Allow Comments',
        REPLY: 'Reply',
        POST: 'Post',
        COMMENT: 'Comment',
        ERROR_MESSAGE: 'There was an issue creating your post. Please try again',
        FORUM_NONMEMBER_MESSAGE:
            '<p>Thank you for visiting the forum community page. We don’t have you on record as part of a forum.</p> <p>If you’re part of a forum, contact <a href="mailto:forumdata@ypo.org?Subject=Cannot%20access%20the%20forum"><span style="color:blue">forumdata@ypo.org</span></a> to make sure your forum is reflected in our database and you can have full access to this page.  If you are not part of a forum and would like to be, contact your chapter forum officer or <a href="mailto:forumdata@ypo.org?Subject=Request%20to%20join%20the%20forum"><span style="color:blue">forumdata@ypo.org</span></a>.</p> <p>And, please take advantage of the other tools on this page, like the Forum Toolkit, where you can find icebreakers and exercises to use in your professional and personal lives.</p>',
        NO_ACTIVITY: 'No activity yet',
        DELETE_CONFIRMATION: 'Are you sure you want to delete?',
        INAPPROPRIATE_CONFIRMATION_PART1: 'Are you sure you want to mark this ',
        INAPPROPRIATE_CONFIRMATION_PART2: ' as Inappropriate?',
        SHOW_MORE_COMMENTS: 'Show More Comments',
        SHOW_FEWER_COMMENTS: 'Show Fewer Comments',
        SHOW_MORE_REPLIES: 'Show More Replies',
        SHOW_FEWER_REPLIES: 'Show Fewer Replies',
        ADD_CHAIR_MESSAGE: 'Add message for chapter',
        HIDE_CONFIRMATION_1: 'Are you sure you want to hide this',
        HIDE_CONFIRMATION_2: 'from your timeline?',
        HIDE_MESSAGE: 'You will no longer see this post in your feed.',
        HIDE_COMMENT: 'You will no longer see this comment in your feed.',
        HIDE_REPLY: 'You will no longer see this Reply in your feed.',
        ENABLE_COMMENT_QUESTION: 'Are you sure you enable comments on this post?',
        DISABLE_COMMENT_QUESTION: 'Are you sure you want to disable comments on this post?',
        REMOVE_TAG: 'Are you sure you want to remove Mention?',
        MENTION: 'Mention',
        CLOSE: 'close',
        CANCEL: 'Cancel',
        REMOVE: 'Remove',
        ENABLE_COMMENT_ICON: 'far fa-comment',
        ENABLE_COMMENT_TITLE: 'Enable Comments',
        DISABLE_COMMENT_ICON: 'fas fa-comment-slash',
        DISABLE_COMMENT_TITLE: 'Disable Comments',
        COMMENTS_HAS_BEEN_DISABLED: 'Comments have been disabled on this post',
        CAN_COMMENT: 'canComment',
        UNDO: 'Undo',
        CONFIRM_INAPPROPIRATE: 'Confirm Inappropriate',
        MAXIMUM_NUMBER_OF_POST_IMAGE: 6,
        SELECT_NETWORK: 'Select Network',
        SHARING_TO_NETWORK_LABEL: 'This post will be shared in ',
        MODERATED_POST_MESSAGE: 'Your post will be reviewed by a moderator before being made public',
        REASON: 'Reason',
        HIDE_REASON: 'Please enter the reason for hiding the post',
        searchResultOffsetStep: 30,
        MEMBER_TEXT_AREA_EDITOR_ID: 'memberMentionText',
        HOME_PAGE_ACTIVITY_FEED_LABEL: 'This is an aggregated feed of people you are following',
        POST_TITLE: 'Post Title (Optional)',
        HOME_PAGE_Follow_LABEL: 'Find news below from ',
        HOME_PAGE_Follow_People_LABEL: 'your Favorites',
    },
    champion: {
      NO_COMMUNITY_MESSAGE: "You haven't joined any Champion Communities yet!",
    },
    group: {
        GROUP_NONMEMBER_MESSAGE_PRE:
            '<h3>You haven’t joined any groups yet!</h3> <p>Explore Groups : <strong>Engage in Member-Driven, Focused Communities</strong></p> <p>YPO groups are a valuable resource for members to share information and ideas. More than 200 groups help members, spouses and partners connect around functional responsibilities, planning efforts, strategic initiatives, and personal, social and work-related topics.</p>',
        EXPLOREGROUPS:
            '<p>Explore Groups : <strong>Engage in Member-Driven, Focused Communities</strong></p> <p>YPO groups are a valuable resource for members to share information and ideas. More than 200 groups help members, spouses and partners connect around functional responsibilities, planning efforts, strategic initiatives, and personal, social and work-related topics.</p>',
        GROUP_NONMEMBER_MESSAGE_POST:
            ' to see a list of available Groups to join or fill the form below to Request a new Group',
        REQUEST_GROUP: 'GROUP CREATION REQUEST',
        REQUEST_GROUP_INFO:
            'All groups are subject to review by YPO management team. Upon approval, the creator and invited members will be notified that the group is active and available for participation',
        COMMUNITY_DIRECTORY: ' Community Directory ',
        COMMUNITY_NO_LONGER_EXIST: "That YPO Connect community no longer exists. Browse the",
        FOR_FULL_LIST_OF_ACTIVE_COMMUNITIES: "for a full list of active communities.",
    },
    ActivityFeed: {
        ALL_COMMUNITY_NON_MEMBER_MESSAGE: 'Activity feed content is exclusive to current members of this ',
    },
    comment: {
        LIKE: 'Like',
        REPLY: 'Reply',
    },
    chairMessage: {
        TITLE_HEADER: 'Message from the Chair',
        CHAIR: 'Chair',
        CLOSE: 'Close',
        ADD_CHAIR_MESSAGE: 'Add Chair Message',
        ADD_SOMETHING_ABOUT_THIS_CHAPTER: 'Add something about this chapter',
        ADD_SOMETHING_ABOUT_THIS_REGION: 'Add something about this region',
        ADD_SOMETHING_ABOUT_THIS_FORUM: 'Add something about this forum',
        ADD_SOMETHING_ABOUT_THIS_NETWORK: 'Add something about this network',
        ADD_SOMETHING_ABOUT_THIS_GROUP: 'Add something about this group',
        ADD_SOMETHING_ABOUT_THIS_BUSINESS: 'Add something about Around Me',
        CHAIR_MESSAGE_EDITOR_ID: 'chairmanMessageEditor',
    },
    CHAPTER_CHAIR_MESSAGE_SHORT_TEXT_LENGTH: 200,
    about: {
        TITLE: 'About',
        ABOUT_MESSAGE_EDITOR_ID: 'aboutMessageEditor',
        CAMERA_ICON: 'photo_camera',
        CLOSE_BTN: 'close',
        ABOUT_COMMUNITY: 'About ',
    },
    transactionHub: {
        TITLE: 'Business Marketplace',
        CARD_TITLE: 'YPO Opportunity Hub',
        CARD_DESCRIPTION: '(formerly Transaction Hub)',
        TRANSACTION_HUB_EDITOR_ID: 'transactionHubEditor',
        BUSINESS_COMMUNITY_TYPE: 'Business',
        ADD_TRANSACTION_HUB_CONTENT: 'Add Business Marketplace Content',
        TITLE_POPUP: 'Before you go..',
        POPUP_DESC: 'By selecting to continue, I acknowledge that I am leaving Connect, the YPO member platform, to access the YPO Opportunity Hub on a third-party website operated by Opportunity Network (“ON”). I understand that I will be subject to ON’s terms and conditions, including its privacy and data use policies. YPO does not endorse and disclaims any information shared or facilitated on the ON platform, including the YPO Opportunity Hub.',
        POPUP_LABEL: 'If I continue, do not show me this message again',
        OPPORTUNITY_URL: 'https://member.opportunitynetwork.com/login/ypo/',
        OPPORTUNITY_DOMAIN: 'member.opportunitynetwork.com',
        EMPTY_GUID: '00000000-0000-0000-0000-000000000000',
        ALL_NETWORKS_COMMUNITY_TYPE: 'Your Networks Consolidated',
    },
    SHOW_MORE_BUTTON: 'Read More',
    CLOSE_BUTTON: 'CLOSE',
    EDIT_BUTTON_ICON: 'edit',
    GLOBAL_REGION_GUID: '30303134-4d30-3030-3031-676264514500',
    REGIONAL_MAP_OF_CHAPTERS: 'Regional Map of Chapters',
    featureEvent: {
        componentNames: {
            manageFeatureEvent: 'ManageFeatureEvent',
            featureEventList: 'FeatureEventList',
            createFeatureEvent: 'CreateFeatureEvent',
            featureEventCarousel: 'FeatureEventCarousel',
        },
        ADD_FEATURE_ITEM: 'Add A Feature Item',
        ADD_WELCOME_MESSAGE: 'Add A Welcome Message',
        ADD_NETWORK_WELCOME_MESSAGE: 'ADD YOUR FEATURED CONTENT HERE',
        MANAGE_FEATURE_ITEMS: 'Manage Feature Items',
        TOP_FOUR_DISPLAYED: 'Top four are displayed to the members',
        TITLE: 'Title',
        LINK_URL: 'Link/URL',
        LINK_PLACEHOLDER: '*Link/URL (example: http://www.ypowpo.org)',
        SUB_TITLE: 'Subtitle',
        REQUIRED_TO_SAVE_TEXT: '*Image and link/URL required.',
        DARKEN_IMAGE: 'Darken Image',
        OPTIONAL_DIMENSION: '<strong>Optimal image dimensions: 620 x 450</strong>',
        DESCRIPTION: 'Description',
        ADD_PHOTO: 'Add Photo',
        REMOVE_PHOTO: 'Remove Photo',
        DELETE_CONFIRMATION: 'Are you sure you want to delete the following item?',
        MAX_ITEMS_FOR_CAROUSEL: 4,
        CAROUSEL_IMAGE_TOGGLE_RATE: 7000,
        errors: {
            TITLE_IS_REQUIRED: 'Title is Required',
            DESCRIPTION_IS_REQUIRED: 'Description is Required',
            URL_LINK_IS_REQUIRED: 'URL link is Required',
            SLD_IS_REQUIRED: 'Please enter a valid link/URL',
        },
        icon: {
            PHOTO: 'photo',
            CLEAR: 'clear',
        },
    },
    chapter_awards: {
        Title_Header: 'Awards',
        Winners: 'Winners',
        Best_Of_Best: 'Global Awards',
    },
    commented_Users: {
        VIEW_PROFILE: 'VIEW PROFILE',
        Add_Comment: 'Type here to add a comment',
        Be_The_First: 'Be the first to comment on this',
    },
    liked_Users: {
        BE_THE_FIRST_TO_LIKE: 'Be the first to like this',
        BE_THE_FIRST_TO_COMMENT: 'Be the first to comment on this',
        Likes: 'Likes',
        Like: 'Like',
    },
    prospects: {
        TITLE: 'Prospect Poll',
        THUMB_UP: 'far fa-thumbs-up',
        THUMB_DOWN: 'far fa-thumbs-down',
        VIEW_RESULTS: 'VIEW CURRENT RESULTS',
        PROSPECTS_FIELDS: {
            FirstName: 'firstName',
            LastName: 'lastName',
            'Primary Email': 'primaryEmail',
            UpVotes: 'upCount',
            DownVotes: 'downCount',
        },
    },
    CommunityOfficer: {
        BLOCK_TITLE: 'Directory',
        MEMBER_COUNT_PRE_TEXT: 'Participants',
        MEMBER_DOWNLOAD_TEXT: 'Download Directory',
        CSV_DOWNLOAD_TEXT: 'csv',
        EXCEL_DOWNLOAD_TEXT: 'xlsx',
        CHAPTER_OFFICERS_PRE_TEXT: 'Chapter Officers',
        REGIONAL_OFFICERS_PRE_TEXT: 'Regional Officers',
        NETWORK_OFFICERS_PRE_TEXT: 'Network Officers',
        GROUP_OFFICERS_PRE_TEXT: 'Group Officers',
        FORUM_OFFICERS_PRE_TEXT: 'Forum Officers',
        VIEW_DIRECTORY_LINK: 'View All',
        MANAGE_IN_SALESFORCE: 'Manage',
        OFFICERS: ' Officers',
        MANAGE_IN_SALESFORCE_GOTO_LINK: 'a0a?rlid=00N61000007Nnca&id=0016100000rqyTR&lsi=3',
        TYPE_FORUM: 'Forum',
    },
    chapterAdmin: {
        MANAGE_MY_CHAPTERS: 'Manage My Chapters',
        CHAPTER_WAIVERS: 'Chapter Waivers',
        CHAPTER_WAIVERS_LIST: 'Chapter Waiver List',
        CA_TOOLS: 'CA Tools',
        CHAPTER_TOOLS: 'Chapter Tools',
        CHAPTER_ADMIN_TOOLS: 'Chapter Admin Tools',
        CHAPTER_MANAGER_TOOLS: 'Chapter Manager Tools',
        FORUM_MANAGEMENT: 'Forum Management',
        CREATE_NEW_FORUM: 'Create New Forum',
        FORUM_MANAGEMENT_COLUMN_TEXT: ['Forum Name', 'Type', 'Status', '# Members', '# Non-Members'],
        FORUM_MANAGEMENT_GOTO_LINK: `001/e?retURL=%2Fcommunities%2Fhome%2Fhome.jsp&RecordType=01261000000WfVm&ent=Account`,
        CHAPTER_OFFICER_MANAGEMENT: 'Chapter Officer Management',
        CHAPTER_NEW_OFFICER: 'Create New Officer',
        CHAPTER_OFFICER_MANAGEMENT_COLUMN_TEXT: ['Position', 'Name', 'Status', 'start Date', 'End Date'],
        CHAPTER_OFFICER_MANAGEMENT_GOTO_LINK: 'a0f/e',
        CHAPTER_MANAGER_TOOLKIT_COMMUNITY_ID: 'ff475a38-8413-4a6a-b678-68016cd73a47',
        PROSPECT_MANAGEMENT: 'Prospect Management',
        CREATE_PROSPECT: 'Create Prospect',
        CHAPTER_MANAGEMENT_SUITE: 'YPO CHAPTER MANAGEMENT HUB',
        PROSPECT_MANAGEMENT_COLUMN_TEXT: [
            'Name',
            'Pursue Status',
            'Lead Status',
            'Qualifying Company',
            'Application Date',
        ],
        PROSPECT_MANAGEMENT_GOTO_LINK: '00Q/e?retURL=%2Fcommunities%2F00Q%2Fo',

        PROSPECTS_READY_TO_PAY: 'Prospects Ready to Pay',
        APPLICATION_LINK: 'Application Link',
        PROSPECTS_READY_TO_PAY_COLUMN_TEXT: ['Name', 'Opportunity Status', 'Date Converted'],
        PROSPECTS_READY_TO_PAY_GOTO_LINK: 'https://www.ypo.org/why-join-ypo/apply-to-ypo/?atc=true&chaptername=',

        CHAPTER_REPORTS: 'Chapter Reports',
        SALESFORCE_REPORTS: 'SALESFORCE REPORTS',
        REPORTS_AND_DASHBOARD: 'Reports & Dashboard',
        REPORTS_AND_DASHBOARD_GOTO_LINK: '00O/o',
        PARTNER_REPORTS: 'Partner Reports',

        PROFILE_DIRECTORY_REPORTS: 'Profile Directory Reports',
        CHAPTER_ROSTER_LISTING: 'Chapter Roster - Listing',
        CHAPTER_ROSTER_LISTING_GOTO_LINK: '00O61000003nE3G?pv2=',
        PROFILE_COMPLETION_REPORT: 'Profile Completion Report',
        PROFILE_COMPLETION_REPORT_GOTO_LINK_PART1: `00O610000043EEn?
ptable0=CONTACT_ID&ocond0=w&rtable0=01I61000000CZH2&rtablecol0=00N61000007Nncj&sfp
c0_0=00N6100000BBD0s&sfpn0_0=eq&sfpv0_0=`,
        PROFILE_COMPLETION_REPORT_GOTO_LINK_PART2: `&sfpc0_1=00N61000007Nnd5
&sfpn0_1=eq&sfpv0_1=True`,
        PREFERRED_CONTACT_DETAILS: 'Preferred Contact Details',
        PREFERRED_CONTACT_DETAILS_GOTO_LINK: '00O61000003nE3V?pv2=',
        PRIMARY_MEMBERS_WITH_RELATIONS: 'Primary Members with Relations',
        PRIMARY_MEMBERS_WITH_RELATIONS_GOTO_LINK: '00O61000003mz86?pv0=',

        FORUM_REPORTS: 'Forum Reports',
        CHAPTER_FORUM_MEMBERSHIP: 'Chapter Forum Membership',
        CHAPTER_FORUM_MEMBERSHIP_GOTO_LINK: '00O4M000004O7nU?pv1=',
        CHPATER_FORUM_MODERATORS_BY_FORUM: 'Chapter Forum Moderators by Forum',
        CHPATER_FORUM_MODERATORS_BY_FORUM_GOTO_LINK: '00O610000046Ltx?pv2=',
        MEMBERS_NOT_IN_FORUM: 'Members Not in Forum',
        MEMBERS_NOT_IN_FORUM_GOTO_LINK_PART1: `00O610000046Lub?ptable0=0726100000CDeVi&ocond0=w&rtable0=01I61000000CZH2&rtablecol0=00N61000007Nncj&sfpc0_0=00N6100000BBD0s&sfpn0_0=eq&sfpv0_0=`,
        MEMBERS_NOT_IN_FORUM_GOTO_LINK_PART2: `&sfpc0_1=00N61000007Nnd5&sfpn0_1=eq&sfpv0_1=True&isdtp=vw`,
        SEE_MORE: 'See More',
        SEE_MORE_GOTO_LINK: '',
        REPORTS_IN_SALESFORCE: 'reports in Salesforce',
        CHAPTER_MEMBERS_WITH_SP_INFORMATION: 'Chapter Members with S/P Information',
        CHAPTER_MEMBERS_WITH_SP_INFORMATION_GOTO_LINK_PART1:
            '00O61000003nSG3?ptable0=CONTACT_ID&ocond0=w&rtable0=01I61000000CZH2&rtablecol0=00N61000007Nncj&sfpc0_0=00N6100000BBD0s&sfpn0_0=eq&sfpv0_0=',
        CHAPTER_MEMBERS_WITH_SP_INFORMATION_GOTO_LINK_PART2: '&sfpc0_1=00N61000007Nnd5&sfpn0_1=eq&sfpv0_1=True',
        CHAPTER_WEB_LOGINS: 'Chapter Web Logins',
        CHAPTER_WEB_LOGINS_LINK: '00O61000003nE2w?pv2=',

        MISCELLANEOUS_MEMBER_INFO_REPORTS: 'Miscellaneous Member Information',
        CHAPTER_COMMITTEE_PARTICIPATION: 'Chapter Committee Participation',
        CHAPTER_COMMITTEE_PARTICIPATION_LINK1:
            '00O61000003n8Uf?ptable0=0726100000BtMDw&ocond0=w&rtable0=01I61000000CZH2&rtablecol0=00N61000007Nncj&sfpc0_0=00N6100000BBD0s&sfpn0_0=eq&sfpv0_0=',
        CHAPTER_COMMITTEE_PARTICIPATION_LINK2: '&sfpc0_1=00N61000007Nnd5&sfpn0_1=eq&sfpv0_1=True',
        CHAPTER_BUSINESS_INFORMATION: 'Chapter Business Information',
        CHAPTER_BUSINESS_INFORMATION_LINK1:
            '00O61000003n0EF?ptable0=CONTACT_ID&ocond0=w&rtable0=01I61000000CZH2&rtablecol0=00N61000007Nncj&sfpc0_0=00N6100000BBD0s&sfpn0_0=eq&sfpv0_0=',
        CHAPTER_BUSINESS_INFORMATION_LINK2: '&sfpc0_1=00N61000007Nnd5&sfpn0_1=eq&sfpv0_1=True',
        MEMBER_EVENT_VOUCHERS: 'Member Event Vouchers',
        MEMBER_EVENT_VOUCHERS_LINK1:
            '00O61000003mlmq?ptable0=CONTACT_ID&ocond0=w&rtable0=01I61000000CZH2&rtablecol0=00N61000007Nncj&sfpc0_0=00N6100000BBD0s&sfpn0_0=eq&sfpv0_0=',
        MEMBER_EVENT_VOUCHERS_LINK2: '&sfpc0_1=00N61000007Nnd5&sfpn0_1=eq&sfpv0_1=True',
        PROSPECTS_LEAD_LISTING: 'Prospects/Lead Listing',
        PROSPECTS_LEAD_LISTING_LINK: '00O610000046Mr4?pv0=',
        CHAPTER_NETWORK_PARTICIPATION: 'Chapter Network Participation',
        CHAPTER_NETWORK_PARTICIPATION_LINK1:
            '00O61000003miUe?ptable0=CONTACT_ID&ocond0=w&rtable0=01I61000000CZH2&rtablecol0=00N61000007Nncj&sfpc0_0=00N6100000BBD0s&sfpn0_0=eq&sfpv0_0=',
        CHAPTER_NETWORK_PARTICIPATION_LINK2: '&sfpc0_1=00N61000007Nnd5&sfpn0_1=eq&sfpv0_1=True',
        CHAPTER_SPOUSE_PARTNER_NETWORK_PARTICIPATION: 'Chapter Spouse/Partner Network Participation',
        CHAPTER_SPOUSE_PARTNER_NETWORK_PARTICIPATION_LINK1:
            '00O61000003nE49?ptable0=CONTACT_ID&ocond0=w&rtable0=01I61000000CZH2&rtablecol0=00N61000007Nncj&sfpc0_0=00N6100000BBD0s&sfpn0_0=eq&sfpv0_0=',
        CHAPTER_SPOUSE_PARTNER_NETWORK_PARTICIPATION_LINK2: '&sfpc0_1=00N61000007Nnd5&sfpn0_1=eq&sfpv0_1=True',

        RENEWALS_REPORTS: 'Renewals Reports',
        RENEWALS_SETUP_REPORTS: 'Renewals Setup Reports',
        RENEWALS_SETUP_REPORTS_LINK: '00O4M000004pgsB?pv0=',
        RENEWALS_PROJECTION_REPORT: 'Renewals Projection Report',
        RENEWALS_PROJECTION_REPORT_LINK1:
            '00O4M000004phsX?ptable0=0724M00000CpurX&ocond0=w&rtable0=01I61000000CZH2&rtablecol0=00N61000007Nncj&sfpc0_0=00N6100000BBD0s&sfpn0_0=eq&sfpv0_0=',
        RENEWALS_PROJECTION_REPORT_LINK2: '&sfpc0_1=00N61000007Nnd5&sfpn0_1=eq&sfpv0_1=True&isdtp=vw',
        MEMBERS_ON_GRACE_CURRENT_FY: 'Members on Grace Current FY',
        MEMBERS_ON_GRACE_CURRENT_FY_LINK: '00O6100000460yP?pv0=',
        GRACE_OR_GRACE_EXTENSION_REQUESTS_NEXT_FY: 'Grace or Grace Extension Requests Next FY',
        GRACE_OR_GRACE_EXTENSION_REQUESTS_NEXT_FY_LINK: '00O6100000460yU?pv0=',
        PRIMARY_AND_SECONDARY_MEMBERS_NOT_RENEWED: 'Primary and Secondary Members Not Renewed',
        PRIMARY_AND_SECONDARY_MEMBERS_NOT_RENEWED_LINK1:
            '00O4M000004phsW?ptable0=0724M00000CpurX&ocond0=w&rtable0=01I61000000CZH2&rtablecol0=00N61000007Nncj&sfpc0_0=00N6100000BBD0s&sfpn0_0=eq&sfpv0_0=',
        PRIMARY_AND_SECONDARY_MEMBERS_NOT_RENEWED_LINK2: '&sfpc0_1=00N61000007Nnd5&sfpn0_1=eq&sfpv0_1=True&isdtp=vw',
        CHAPTER_DUES_COLLECTED_BY_THE_CHAPTER: 'Chapter Dues Collected by the Chapter',
        CHAPTER_DUES_COLLECTED_BY_THE_CHAPTER_LINK: '00O6100000460yo?pv3=',

        MEMBERS_IN_NONCHAPTER_FORUMS: 'Members in Non-Chapter Forums',
        MEMBERS_IN_NONCHAPTER_FORUMS_LINK1: '00O4M000004O7nV?pv2=',
        MEMBERS_WITHOUT_FORUM_TRAINING: 'Members without Forum Training',
        MEMBERS_WITHOUT_FORUM_TRAINING_LINK1: '00O4M000004OK94UAG?pv5=',
        MEMBERS_WITHOUT_FORUM_TRAINING_LINK2:
            '&ocond0=wo&rtable0=01I61000000CZH6&rtablecol0=00N61000007Nncc&sfpc0_0=00N6100000DIa3a&sfpn0_0=eq&sfpv0_0=Forum:%20Fundamentals%20(FF),Forum%20Fundamentals,Forum%20Moderator%20Leadership%20Development,Forum%20Supercharge,Forum:%20Moderator%20Leadership%20Development%20(FMLD)&isdtp=vw',
        MODERATOR_CONTACT_LIST: 'Moderator Contact List',
        MODERATOR_CONTACT_LIST_LINK1: '00O610000046Lxz?pv4=',
        MODERATORS_FMLD_TRAINED: 'Moderators FMLD Trained',
        MODERATORS_FMLD_TRAINED_LINK1: '00O4M000004OH2o?pv2=',
        MODERATORS_FMLD_TRAINED_LINK2:
            '&ocond0=w&rtable0=01I61000000CZH6&rtablecol0=00N61000007Nncc&sfpc0_0=00N61000007Nnff&sfpn0_0=eq&sfpv0_0=Forum%20Moderator%20Leadership%20Development,Forum:%20Moderator%20Leadership%20Development%20(FMLD)&isdtp=vw',
        MODERATORS_FMLD_NOT_TRAINED: 'Moderators FMLD Not Trained',
        MODERATORS_FMLD_NOT_TRAINED_LINK1: '00O4M000004OH2j?pv2=',
        MODERATORS_FMLD_NOT_TRAINED_LINK2:
            '&ocond0=wo&rtable0=01I61000000CZH6&rtablecol0=00N61000007Nncc&sfpc0_0=00N61000007Nnff&sfpn0_0=eq&sfpv0_0=Forum%20Moderator%20Leadership%20Development,Forum:%20Moderator%20Leadership%20Development%20(FMLD)&isdtp=vw',
        FORUM_AFFILIATIONS: 'Forum Affiliations',
        FORUM_AFFILIATIONS_LINK1:
            '00O610000042TTs?ptable0=CONTACT_ID&ocond0=w&rtable0=01I61000000CZH2&rtablecol0=00N61000007Nncj&sfpc0_0=00N6100000BBD0s&sfpn0_0=eq&sfpv0_0=',
        FORUM_AFFILIATIONS_LINK2: '&sfpc0_1=00N61000007Nnd5&sfpn0_1=eq&sfpv0_1=True&isdtp=vw',
        CHAPTER_HEALTH_YOY_REPORT_TYPE: 'ChapterHealthYOYReport',
        SEEMORE_TYPE: 'SeeMore',
    },
    filesAndMedia: {
        HYBRID_UI_MESSAGE_FOR_FILES_MEDIA: 'Please visit Connect in a browser to access Files and Media',
        ERROR_WHILE_UPLOADING: 'Error While Uploading',
        SAVE: 'Save',
        DELETE: 'Delete',
        UPDATE: 'Update',
        REORDER: 'Reorder',
        DATA_SAVE_CONF_MESSAGE: 'Would you like to save your changes ?',
        DATA_REORDER_CONF_MESSAGE: 'Would you like to save your reorder changes ?',
        LINK_COPIED_MESSAGE: 'Link Copied',
        COPYLINK_TOOLTIP: 'Copy Link',
        SHARELINK_TOOLTIP: 'Share Link',
        ADD_FILE_TOOLTIP: 'Add a File',
        DIRECTORY_ALREADY_EXISTS: 'Directory already exists',
        newfolder: {
            id: 0,
            parentId: null,
            name: 'New Folder',
            order: 1,
            fixed: false,
            isFolder: true,
            fileSubType: 'folder',
            createdDate: '',
            fileSize: '0 kb',
            isEditRow: false,
            isNewRow: true,
            isDeleteRow: false,
        },
        FILETYPES_SUPPORTED: [
            '.mp3',
            '.mp4',
            '.csv',
            '.doc',
            '.docx',
            '.xls',
            '.xlsx',
            '.pdf',
            '.pps',
            '.ppsx',
            '.ppt',
            '.pptx',
            '.rtf',
            '.txt',
            '.vsd',
            '.wbp',
            '.xps',
            '.txt',
            '.xlt',
            '.bmp',
            '.gif',
            '.jpeg',
            '.jpg',
            '.png',
        ],
        FILE_NOT_SUPPORTED: 'File type not supported',
        FILE_NAME_LENGTH_EXCEEDED: 'Maximum filename length is 40 characters',
        FILENAME_ALREADY_EXISTS: 'File name already exists',
        FOlDERNAME_ALREADY_EXISTS: 'Folder name  already exists',
        ERROR_MESSAGE_TIMEOUT_SECONDS: '3000',
        UPLOADING: 'UPLOADING',
        BROWSE: 'BROWSE OR',
        DRAG_FILES_HERE: 'DRAG FILES HERE TO ADD',
        TITLE: 'Files and Media',
        PLEASE_ENTER_FOLDER_NAME: 'Please Enter Folder Name',
        FIELD_SHOULD_NOT_BE_EMPTY: 'Field should not be empty',
        actions: {
            ADD_FOLDER: 'Add a Folder',
        },
        NO_MEDIA: 'No folders created',
        tableColumns: {
            TYPE: {
                key: 'TYPE',
                value: 'type',
            },
            NAME: {
                key: 'NAME',
                value: 'name',
            },
            MODIFIED_BY: {
                key: 'MODIFIED BY',
                value: 'updatedUser',
            },
            LAST_MODIFIED: {
                key: 'LAST MODIFIED DATE',
                value: 'lastModifiedDate',
            },
        },
        icon: {
            CLOSE: 'close',
        },
        FOLDER: 'folder',
        ITEM: 'Item',
        ITEMS: 'Items',
        FILE: 'File',
        FILES: 'Files',
        DELETE_CONFIRMATION: 'Are you sure want to delete the item ?',
        FILES_COUNT: '0',
        LAST_MODIFIED_DATE: 'Last Modified Date',
        BYTES: 'bytes',
        KB: ' KB',
        MB: 'MB',
        DUPLICATE_NAME: 'File/Folder name already exist',
        ADD_FOLDER: 'ADD A FOLDER',
        DOWNLOAD: 'Download',
        SHARE: 'Share',
        EDIT: 'Edit',
        PREVIEW: 'Preview',
        NEW_FOLDER: 'New Folder',
        ACTIONS: {
            NEW: 'new',
            EDIT: 'edit',
            HOME: 'home',
            DELETE: 'delete',
            FOLDER: 'folder',
            CLOSE: 'close',
            REORDER: 'reorder',
        },
    },
    regionChapters: {
        ALL: 'All',
        YPO_Chapter: 'YPO Chapter',
        YPO_Gold_Chapter: 'YPO Gold Chapter',
        YPO_Integrated_Chapter: 'YPO Integrated Chapter',
        NO_Chapters: 'No chapters to Display',
        NO_YPO_Chapters: 'No YPO chapters to Display',
        NO_YPO_GOLD_Chapters: 'No YPO Gold chapters to Display',
        Title: 'Region Chapters',
    },
    chapterTypeIconConstant: {
        YPO_Integrated_Chapter: 'https://res.cloudinary.com/ypoconnect-prod/image/upload/f_auto,q_auto/chapterpins/Pin_5.png',
        YPO_Gold_Chapter: 'https://res.cloudinary.com/ypoconnect-prod/image/upload/f_auto,q_auto/chapterpins/Pin_4.png',
        YPO_Chapter: 'https://res.cloudinary.com/ypoconnect-prod/image/upload/f_auto,q_auto/chapterpins/Pin_3.png',
    },
    welcomeChapterMessage: [
        { label: 'ANNUAL_COMPENSATION', key: 'annualCompensation', currency: true , value:'Annual Compensation'},
        { label: 'ANNUAL_REVENUE', key: 'annualRevenue', currency: true,value:'Annual Revenue' },
        { label: 'ENTERPRISE_NET_WORTH_TYPE', key: 'enterpriseNetWorthType', currency: true , value:'Enterprise Net Worth Type'},
        { label: 'MINIMUM_ENTERPRISE_NET_WORTH', key: 'minimumEnterpriseNetWorth', currency: true , value:'Min Enterprise Net Worth'},
        { label: 'EMPLOYEES', key: 'employees', currency: false , value:'Employees'},
        { label: 'ASSETS', key: 'assets', currency: true, value:'Assets' },
        { label: 'PUBLIC_ENTITY_VALUE', key: 'publicEquityValue', currency: true , value:'Public Equity Value'},
    ],
    ADDITIONAL_MEMBERSHIP_REQUIREMENTS: 'Additional Membership Requirements',
    YPO_HOME: 'YPO Home',
    ALL_NETWORKS: 'All Networks',
    YOU_HAVENOT_JOINED_ANY: `You haven’t joined any`,
    INAPPROPRIATE_POSTS: 'Inappropriate Content',
    YET: 'yet!',
    AROUND_ME: 'Eat/Drink/Sleep – AroundMe',
    TRUE: 'True',
    EMPTY_GUID: '00000000-0000-0000-0000-000000000000',
    TECHNOLOGY_NETWORK_ID: '1e20969e-7d4f-de11-9c44-005056921c55',
};

export const likeStatement = (activity) => {
    let likeMsg = '';
    if (activity.likeCount > 0) {
        const updatedLikeCount = activity.likeCount - 1;
        if (!activity.userHasLiked) {
            if (activity.likeCount === 1) {
                likeMsg = `${activity.lastLiker} likes this`;
            }
            if (activity.likeCount >= 2) {
                likeMsg = `${activity.likeCount} likes`;
            }
        }
        if (activity.userHasLiked) {
            if (activity.likeCount === 1) {
                likeMsg = `You have liked this`;
            }
            if (activity.likeCount > 1) {
                likeMsg = `You and ${updatedLikeCount} ${
                    updatedLikeCount > 1 ? 'others like this' : 'other like this'
                }`;
            }
        }
    }
    return likeMsg;
};

export const chapterManagementBannerText = (url, target) => {
    return `<b>Once you complete training for the new Chapter Management Hub, select the button to continue.</b><br><span style="font-size:12.5px;">Please plan to complete training no later than 30 April. For questions contact your Regional Manager or the <a href="${url}" style="color:white;" target="${target}">YPO Concierge.</a></span>`;
};

// Comments Count and Names displaying
export const commentStatement = (activity) => {
    let commentMsg = '';
    const fcLength = activity.featuredComments.length;
    if (fcLength > 0) {
        const Username = `${activity.featuredComments[fcLength - 1].authorFirstName} ${
            activity.featuredComments[fcLength - 1].authorLastName
        }`;
        const updatedCommentCount = activity.totalCommentedUsers - 1;
        if (activity.commentCount > 0) {
            if (!activity.userHasCommented) {
                if (activity.totalCommentedUsers === 1) {
                    commentMsg = `${Username} has commented`;
                }
                if (activity.totalCommentedUsers > 1) {
                    commentMsg = `${Username} and ${updatedCommentCount} has commented`;
                }
            }
            if (activity.userHasCommented) {
                if (activity.totalCommentedUsers === 1) {
                    commentMsg = `You have commented`;
                }
                if (activity.totalCommentedUsers > 1) {
                    commentMsg = `You and ${updatedCommentCount} ${
                        updatedCommentCount > 1 ? 'others commented on this' : 'other commented on this'
                    }`;
                }
            }
        }
    }
    return commentMsg;
};

//Ending
export const postActionPermissions = {
    copyLink: 'copyLink',
    default: 'default',
    edit: 'edit',
    inappropriatePost: 'inappropriatePost',
    delete: 'delete',
    isMentioned: 'isMentioned',
    show: 'show',
};

export const postActions = [
    {
        name: 'edit',
        title: 'Edit',
        icon: 'far fa-edit',
        onClick: 'editPost',
        requiredPermissions: [postActionPermissions.edit],
    },
    {
        name: 'copy',
        title: 'Copy link to post',
        icon: 'fa fa-link',
        onClick: 'copyLink',
        requiredPermissions: [postActionPermissions.copyLink],
    },
    {
        name: 'hidePost',
        title: 'Hide Post',
        icon: 'fas fa-times',
        onClick: 'promptHidePost',
        requiredPermissions: [postActionPermissions.default],
    },
    {
        name: 'delete',
        title: 'Delete',
        icon: 'far fa-trash-alt',
        onClick: 'promptDeletePost',
        requiredPermissions: [postActionPermissions.delete],
    },
    {
        name: 'canComment',
        title: '',
        icon: '',
        onClick: 'promptCanEditCommentHandlerBox',
        requiredPermissions: [postActionPermissions.edit],
    },
    {
        name: 'inappropriatePost',
        title: 'Inappropriate Post',
        icon: 'far fa-flag',
        onClick: 'promptInappropriatePost',
        requiredPermissions: [postActionPermissions.inappropriatePost],
    },
    {
        name: 'removeMention',
        title: 'Remove Mention',
        icon: 'fas fa-tag',
        onClick: 'promptRemoveMention',
        requiredPermissions: [postActionPermissions.isMentioned],
    },
];

export const moderationActions = [
    {
        name: 'edit',
        title: 'Edit',
        icon: 'far fa-edit',
        onClick: 'editPost',
        requiredPermissions: [postActionPermissions.edit],
    },
    {
        name: 'hide',
        title: 'Hide',
        icon: 'fas fa-eye-slash',
        onClick: 'showHideReasonBox',
        requiredPermissions: [postActionPermissions.default],
    },
    {
        name: 'show',
        title: 'Show',
        icon: 'fas fa-eye',
        onClick: 'confirmShowModeratedPost',
        requiredPermissions: [postActionPermissions.show],
    },
];

export const commentActions = [
    {
        name: 'edit',
        title: 'Edit',
        icon: 'far fa-edit',
        onClick: 'editPost',
        requiredPermissions: [postActionPermissions.edit],
    },
    {
        name: 'hideComment',
        title: 'Hide Comment',
        icon: 'fas fa-times',
        onClick: 'promptHidePost',
        requiredPermissions: [postActionPermissions.default],
    },
    {
        name: 'delete',
        title: 'Delete',
        icon: 'far fa-trash-alt',
        onClick: 'promptDeletePost',
        requiredPermissions: [postActionPermissions.delete],
    },
    {
        name: 'inappropriateComment',
        title: 'Inappropriate Comment',
        icon: 'far fa-flag',
        onClick: 'promptInappropriatePost',
        requiredPermissions: [postActionPermissions.inappropriatePost],
    },
];

const commonFileTypeStrings = {
    imageFileTypes: ['image', 'jpeg', 'pic', 'jpg', 'gif', 'bmp', 'png'],
    excelFileTypes: ['sheet', 'excel', 'xlsx', 'xls', 'xlt', 'csv', 'xps'],
    wordFileTypes: ['word', 'wordprocessingml', 'doc', 'docx', 'rtf'],
    pdfFileTypes: ['pdf'],
    videoFileTypes: ['video', 'mp4'],
    audioFileTypes: ['audio', 'mp3'],
    textFileTypes: ['text', 'txt'],
    archiveFileTypes: ['zip'],
    powerpointFileTypes: ['presentation', 'ppt', 'pptx', 'pps', 'ppsx'],
};

export const iconClassNames = (filetype) => {
    const fileTypes = commonFileTypeStrings;
    let iconClass;
    if (filetype === 'folder') {
        iconClass = 'fas fa-folder';
    } else if (new RegExp(fileTypes.excelFileTypes.join('|')).test(filetype)) {
        iconClass = 'far fa-file-excel';
    } else if (new RegExp(fileTypes.imageFileTypes.join('|')).test(filetype)) {
        iconClass = 'far fa-file-image';
    } else if (new RegExp(fileTypes.pdfFileTypes.join('|')).test(filetype)) {
        iconClass = 'far fa-file-pdf';
    } else if (new RegExp(fileTypes.wordFileTypes.join('|')).test(filetype)) {
        iconClass = 'far fa-file-word';
    } else if (new RegExp(fileTypes.videoFileTypes.join('|')).test(filetype)) {
        iconClass = 'far fa-file-video';
    } else if (new RegExp(fileTypes.audioFileTypes.join('|')).test(filetype)) {
        iconClass = 'far fa-file-audio';
    } else if (new RegExp(fileTypes.textFileTypes.join('|')).test(filetype)) {
        iconClass = 'far fa-file-alt';
    } else if (new RegExp(fileTypes.archiveFileTypes.join('|')).test(filetype)) {
        iconClass = 'far fa-file-archive';
    } else if (new RegExp(fileTypes.powerpointFileTypes.join('|')).test(filetype)) {
        iconClass = 'far fa-file-powerpoint';
    } else {
        iconClass = 'far fa-file-alt';
    }
    return iconClass;
};

export const calculateFileSize = (sizeInBytes, MeasureConsts) => {
    let size;
    const sizeInKB = sizeInBytes / 1024;
    if (sizeInKB >= 1) {
        const sizeInMB = sizeInKB / 1024;
        if (sizeInMB > 1) {
            size = `${Math.round(sizeInMB * 100) / 100} ${MeasureConsts.MB}`;
        } else {
            size = `${Math.round(sizeInKB * 100) / 100} ${MeasureConsts.KB}`;
        }
    } else {
        size = `${Math.round(sizeInBytes * 100) / 100} ${MeasureConsts.BYTES}`;
    }
    return size;
};

export const replyActions = (() => {
    return commentActions.map((item) => {
        return {
            name: item.name.replace('Comment', 'Reply'),
            title: item.title.replace('Comment', 'Reply'),
            icon: item.icon,
            onClick: item.onClick,
            requiredPermissions: item.requiredPermissions,
        };
    });
})();

export const prepareFeatureItemsForDragDrop = (data) => {
    data.eventList.forEach((d, idx) => {
        d.i = getRandomId();
        d.x = 0;
        d.y = idx;
        d.h = 1;
        d.w = 1;
    });
    return data;
};

export const upcomingEventsConstant = {
    REGISTER: 'Register',
    REGISTERED: 'Registered',
    DECLINE: 'Decline',
    EDIT_REGISTERED: 'Edit Registration',
    CHAPTER_TITLE: 'Upcoming Chapter Events',
    NETWORK_TITLE: 'Upcoming Network Events',
    REGION_TITLE: 'Upcoming Region Events',
    FORUM_TITLE: 'Upcoming Forum Events',
    HOME_TITLE: 'My Upcoming Events',
    COMMUNITIES_TITLE: 'Upcoming Community Events',
    CONSIDER_THESE_EVENTS: 'Consider These Events',
    REGISTRATION_URL: 'http://event.ypo.org/d/2gqq36/4W',
    MY_EVENTS: 'myEvents',
    Sponsors: 'sponsors',
    SEARCH_FILTER_KEY: 'AttendeeIds',
    EVENT_NAME: "My Events",
    SEARCH_RIBBON_GROUP_NAME: 'Sponsors',
    RSVP: 'RSVP',
};

export const announcementConstants = {
    TITLE: 'Announcement',
};

export const toolKitConstants = {
    FORUM_TOOLKIT: 'Forum Toolkit',
    SEARCH: 'Search',
    FORUM_MEETING_TOOLS: 'Forum Meeting Tools',
    MY_MEETINGS: 'My Meetings',
    QUICK_MEETING: 'Quick Meeting',
    CASE_STUDY: 'Case Study',
    CLEAR: 'CLEAR',
    FILTER: 'Filter',
    APPLY: 'APPLY FILTER',
    TIME_LENGTH: 'TIME LENGTH',
    TOPIC: 'TOPIC',
    NEED_MATERIALS: 'REMOVE CONTENT WITH MATERIALS',
    RECENTLY_ADDED: 'RECENTLY ADDED',
    MIN_RANGE: 5,
    MAX_RANGE: 240,
    STEP_RANGE: 5,
    NO_DATA_AVAILABLE: 'No Data Available',
    ALL_TOOLKIT_CONTENT: 'All Toolkit Content',
    COPY_CLIPBOARD: 'Copy URL to clipboard',
    EXERCISE_URL: 'exerciseUrl',
};

export const networkConstants = {
    APPROVED_INVITE_SUCCESSFULLY: 'Approved Invite Successfully',
    ERROR_WHILE_APPROVING: 'Error while Approving',
    YPO_NETWORK: 'YPO Networks',
    YPO_NETWORK_TYPES: ['ALL', 'BUSINESS', 'FAMILY', 'PERSONAL', 'IMPACT'],
    LINK_PLACEHOLDER: 'Add a Link*',
    TITLE_PLACEHOLDER: 'Add a Title*',
    ADD_COMMUNITIES: 'ADD COMMUNITIES',
    RELATED_COMMUNITIES: 'Related Communities',
    errors: {
        TITLE_IS_REQUIRED: 'Title is Required',
        URL_LINK_IS_REQUIRED: 'URL link is Required',
    },
    PENDING_REQUESTS: 'Pending Requests',
    DENY_MESSAGE: 'You have denied this request',
    APPROVE_MESSAGE: 'You have approved this request',
    APPROVE: 'Approve',
    DENY: 'Deny',
    NO_PENDING_REQUESTS: 'There are no pending requests.',
    REJECTED_REASON: 'Denial Reason',
    SEARCH_PROFILE: 'Search for profile',
    BULK_INVITE: 'Bulk Invite',
    SEND: 'Send ',
    INVITIES: ' Invites To...',
    FORCE_ADD_COMMUNITY: 'FORCE ADD TO THE COMMUNITY?',
    SUB_NETWORK: 'Sub-Networks',
    PASTE_EMAIL_ADDRESS: 'PASTE EMAIL ADDRESS',
    ADDRESS_ASSOCIATION: 'Address must be associated with a profile',
    BULK_INVITE_WARNING_MESSAGE:
        'Before clicking the Send button, please press Enter/Return key on your keyboard in order to confirm the emails are valid',
    ERROR_WHILE_INVITING: 'Error while Inviting',
    SINGLE_MEMBER_INVITE_ERROR: 'This member does not meet the eligibility criteria.',
    BULK_INVITE_ERROR: 'Some of the members do not meet the eligibility criteria.',
    ALL: 'all',
    IMPACT: 'impact',
    SOCIAL: 'social',
};

export const communitiesConstants = {
    YPO_COMMUNITIES: 'YPO Communities',
    ADD_COMMUNITIES_QUICK_LINKS: 'Add Community Quick Links',
    COMMUNITY_QUICK_LINKS: 'Community Quick Links',
};

export const chapterConstants = {
    CHAPTER_QUICKLINKS: 'Chapter Quick Links',
    ADD_CHAPTER_QUICK_LINKS: 'ADD QUICKLINK',
    DELETE_CONFIRMATION: 'Are you sure you want to delete?',
    CANCEL: 'Cancel',
    OK: 'Ok',
    LINK_PLACEHOLDER: 'Add a Link*',
    TITLE_PLACEHOLDER: 'Add a Title*',
    MAX_LIMIT_REACHED_MESSAGE: 'Maximum number of links has been reached.',
    CLOSE: 'Close',
}

export const recommendationConstants = {
    TITLE_MEMBERS: 'Recommended Members',
    MY_RECOMMENDED_EVENTS: 'My Recommended Events',
    CONNECT: 'Connect',
    NOT_INTERESTED: 'Not Interested',
    ACCEPT: 'Accept',
    FIFTY: 50,
    TWENTY: 20,
};

export const recommendedEventsFilterParams = (memberId) => {
    return [
        {
            label: 'Recommended Events',
            filterKey: 'RecommendedEvents',
            filterValue: memberId,
            ribbonGroupName: 'My Events',
        },
    ];
};

export const createFilterFromCommunityData = (communityData, filterFacetKeyName) => {
    const filters = {};
    filters.label = communityData ? communityData.name : null;
    filters.filterValue = communityData ? communityData.searchFilterValue : null;
    filters.filterKey = communityData ? communityData.searchFilterKey : null;
    filters.ribbonGroupName = communityData ? communityData.searchRibbonGroupName : null;
    const searchFilterFacet = communityData ? communityData.searchFilterFacet : null;
    return {
        [filterFacetKeyName || searchFilterFacet]: [filters],
    };
};

export const createFilterForUpComingEvents = (communityData, isForSponsors) => {
    const filter = {};
    if (isForSponsors) {
        filter.label = communityData.name;
        filter.filterValue =
            communityData.searchFilterValue && communityData.searchFilterValue.indexOf('>') === 0
                ? communityData.searchFilterValue
                : communityData.name;
        filter.filterKey = communityData.searchFilterKey;
        filter.ribbonGroupName = 'Sponsors';
    } else {
        filter.label = `My ${communityData.communityType}s only`;
        filter.filterValue = `My${communityData.communityType}s`;
        filter.filterKey = `${communityData.communityType}Ids`;
        filter.ribbonGroupName = communityData.searchRibbonGroupName;
    }
    filter.isTypeAhead = false;
    filter.isDropdown = false;
    return filter;
};

export const createCommunityFilter = (community) => {
    let result = {};
    if (community) {
        if (community.isMember && (community.communityType.toLowerCase() === 'chapter'  || community.communityType.toLowerCase() === 'network')) {
            result = {
                label: community.name || '',
                filterKey: `${community.communityType}s`,
                filterValue: community.name || '',
                count: 1,
                ribbonGroupName: `My ${community.communityType}s`,
            };
        } else {
            result = {
                label: community.name || '',
                filterKey: `${community.communityType}s`,
                filterValue: community.name || '',
                count: 1,
                ribbonGroupName: 'Sponsors',
                parentKey: 'sponsors',
            };
        }

    }
    return result;
};

export const createFilterForRegisteredEvents = (communityData) => {
    const filter = {};
    filter.label = communityData.name;
    filter.filterValue = communityData.searchFilterValue;
    filter.filterKey = communityData.searchFilterKey;
    filter.ribbonGroupName = communityData.searchRibbonGroupName;
    return filter;
};

export const setCookie = (cname, cvalue, exdays) => {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cname}= ${cvalue}; ${expires}; path=/`;
};

export const getCookie = (cname) => {
    const name = `${cname}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};

export const showTransactionHubPopup = (event, isMobileAppBrowser) => {
    const opportunityURL = document.activeElement.href || event.target.href;
    const isTransactionHubCookieAccepted = getCookie('TransactionHubAcknowledgement');

    if (opportunityURL && opportunityURL.toLowerCase().includes(communityCommonConstant.transactionHub.OPPORTUNITY_DOMAIN)) {
        event.preventDefault();
        if (isTransactionHubCookieAccepted) {
            window.open(communityCommonConstant.transactionHub.OPPORTUNITY_URL, isMobileAppBrowser ? "_self" : "_blank");
        } else {
            return true;
        }
    }
    return false;
};

export const getParentOrCommunityId = (communityList, communityId) => {
    const community = communityList.find(com => com.communityId === communityId);
    if (community && community.communityType.toLowerCase() === 'chapter') {
        return community.parentId
    }
    return communityId;
}

